import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { NAVBAR_WORKSPACE_SLOT_ID } from '@/components/molecules/Navbar';
import { WorkspaceSwitcher } from '@/features/workspaces/components/WorkspaceSwitcher';

/** The switcher in the navbar slot after the logo, behind a separator 20px from the title. */
export function NavbarWorkspaceSwitcher(props: Parameters<typeof WorkspaceSwitcher>[0]) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => setSlot(document.getElementById(NAVBAR_WORKSPACE_SLOT_ID)), []);
  if (!slot) return null;
  return createPortal(
    <>
      <span aria-hidden className="mx-5 h-6 w-px shrink-0 bg-border" />
      <div className="min-w-0 max-w-[296px]">
        <WorkspaceSwitcher {...props} />
      </div>
    </>,
    slot,
  );
}
